import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";

import { NavigationItem } from "./navigation-item";
import { Notification } from "./notification";
import { SharedCommonService } from "app/shared/shared-common.service";
import { User } from "app/shared/shared.module";
import { Subscription, Observable } from "rxjs/Rx";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";
import { AuthenticationService } from "app/brightserve/authentication.service";

@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
    
    User: User;
    clockSub: Subscription;
    sub: Subscription;
    Clock: Date;

	SelectedMenu: NavigationItem;
	NavigationMenu: NavigationItem[] = [];

	Notifications: Notification[] = [
	//	new Notification({
	//		Title: "New User Registered.",
	//		Date: new Date(),
	//		Type: 'new',
 //           Unread: true
	//	}),
	//	new Notification({
	//		Title: "New Case Recieved.",
	//		Date: new Date('2017-07-07T12:34:33+00:00'),
	//		Type: 'notification',
	//		Unread: true
	//	}),
	//	new Notification({
	//		Title: "New Case Recieved.",
	//		Date: new Date('2017-07-07T10:34:33+00:00'),
	//		Type: 'notification',
	//		Unread: false
	//	}),
	//	new Notification({
	//		Title: "New Emergency Case.",
	//		Date: new Date('2017-05-07T12:34:33+00:00'),
	//		Type: 'emergency',
	//		Unread: false
	//	})
    ];

    constructor(private sharedCommonService: SharedCommonService, private busyLoaderService: BusyLoaderService, private router: Router, private authenticationService: AuthenticationService) {
	}

    ngOnInit() {
        this.clockSub = Observable.interval(1000).map(tick => new Date()).subscribe((time) => this.Clock = time);
        var ob = this.sharedCommonService.GetUserDetails();
        this.busyLoaderService.AddLoadingObservable(ob);
        this.sub = ob.subscribe(
            data => {
                this.User = new User(data.User);
                if (this.User.IsAdmin) {
                    this.NavigationMenu.push(new NavigationItem({
                        Name: "Clients",
                        Icon: "user",
                        URL: "/clients"
                    }));
                    this.NavigationMenu.push(new NavigationItem({
                        Name: "Admin Area",
                        Icon: "equalizer",
                        URL: "/admin",
                        Children: [],
                        Admin: true
                    }));
                }
                else
                {
                    this.NavigationMenu.push(new NavigationItem({
                        Name: "Dashboard",
                        Icon: "home",
                        URL: "/dashboard",
                        Children: []
                    }));
                    this.NavigationMenu.push(new NavigationItem({
                        Name: "Cases",
                        Icon: "briefcase",
                        URL: "/cases",
                        Children: [
                            new NavigationItem({ Name: "Current", URL: "/cases/current" }),
                            new NavigationItem({ Name: "Suspended", URL: "/cases/suspended" }),
                            new NavigationItem({ Name: "Closed", URL: "/cases/closed" })
                        ]
                    }));
                    this.NavigationMenu.push(new NavigationItem({
                        Name: "Emergency Medical Guidelines",
                        Icon: "book-open",
                        URL: "/library/reference",
                        Children: []
                    }));
                    this.NavigationMenu.push(new NavigationItem({
                        Name: "Medical Manual",
                        Icon: "book-open",
                        Link: "/assets/MedicalEmergencyHandbook.pdf",
                        Children: []
                    }));
                }
            }
        );
    };

    ngOnDestroy() {
        this.clockSub.unsubscribe();
        this.sub.unsubscribe();
    };

    ToggleMenu() {
        if (this.sharedCommonService.OnMobile)
            this.sharedCommonService.ToggleMenu("menu-btn");
    };

    Logout() {
        this.authenticationService.logout();
    }
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.ts